import { useState } from 'react';
import familyRetreatImg from '@/assets/family-retreat.jpg';
import natureRetreatImg from '@/assets/nature-retreat-yoga.jpg';
import forestPathImg from '@/assets/forest-path.jpg';
import heroCabinImg from '@/assets/hero-cabin.jpg';
import freshMonsteraImg from '@/assets/fresh-monstera.jpg';
import monsteraAccentImg from '@/assets/monstera-accent.jpg';

interface PolaroidPhoto {
  id: number;
  src: string;
  alt: string;
  rotation: number;
  x: number;
  y: number;
  caption?: string;
}

export const BackgroundPolaroids = () => {
  // Photos scattered across different sections of the website
  const [photos] = useState<PolaroidPhoto[]>([
    { id: 1, src: forestPathImg, alt: "Forest path", rotation: -12, x: 15, y: 120 }, // Manifest section
    { id: 2, src: natureRetreatImg, alt: "Yoga in nature", rotation: 18, x: 85, y: 180 }, // Values section
    { id: 3, src: freshMonsteraImg, alt: "Fresh monstera", rotation: -6, x: 8, y: 280 }, // About section
    { id: 4, src: heroCabinImg, alt: "Forest cabin", rotation: 22, x: 90, y: 350 }, // Services section
    { id: 7, src: monsteraAccentImg, alt: "Monstera plant", rotation: -20, x: 5, y: 600 }, // Footer area
  ]);

  console.log('BackgroundPolaroids rendering with', photos.length, 'photos');
  
  return (
    <div className="absolute inset-0 pointer-events-none z-10 overflow-hidden">
      {photos.map((photo) => (
        <div
          key={photo.id}
          className="absolute transition-all duration-300 hover:scale-105 hover:z-10 pointer-events-auto"
          style={{
            left: `${photo.x}%`,
            top: `${photo.y}vh`,
            transform: `translate(-50%, -50%) rotate(${photo.rotation}deg)`,
            filter: 'none',
            opacity: '0.6',
          }}
        >
          <div className="bg-white p-3 pb-12 shadow-xl max-w-[160px] md:max-w-[180px] relative group cursor-pointer">
            <div className="aspect-square overflow-hidden bg-muted">
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            {/* Tape effect */}
            <div className="absolute -top-1 left-4 w-8 h-4 bg-yellow-100/70 rotate-12 shadow-sm"></div>
            <div className="absolute -top-1 right-4 w-8 h-4 bg-yellow-100/70 -rotate-12 shadow-sm"></div>
          </div>
        </div>
      ))}
    </div>
  );
};